export const GET_WORKORDERS = "GET_WORKORDERS"
export const GET_WORKORDERS_SUCCESS = "GET_WORKORDERS_SUCCESS"
export const GET_WORKORDERS_FAIL = "GET_WORKORDERS_FAIL"

export const ADD_WORKORDER = "ADD_WORKORDER"
export const ADD_WORKORDER_SUCCESS = "ADD_WORKORDER_SUCCESS"
export const ADD_WORKORDER_FAIL = "ADD_WORKORDER_FAIL"

export const UPDATE_WORKORDER = "UPDATE_WORKORDER"
export const UPDATE_WORKORDER_SUCCESS = "UPDATE_WORKORDER_SUCCESS"
export const UPDATE_WORKORDER_FAIL = "UPDATE_WORKORDER_FAIL"

export const DELETE_WORKORDER = "DELETE_WORKORDER"
export const DELETE_WORKORDER_SUCCESS = "DELETE_WORKORDER_SUCCESS"
export const DELETE_WORKORDER_FAIL = "DELETE_WORKORDER_FAIL"

export const SET_WORKORDER_FIELD_ERRORS = "SET_WORKORDER_FIELD_ERRORS"
